
import CryptoJS from 'crypto-js'

export function interceptorResponseAxios(responseEncrypt) {
	try {
		const { responseZeloCriptografia } = responseEncrypt.data
		if (responseZeloCriptografia) {
			responseEncrypt.data = JSON.parse(CryptoJS.AES.decrypt(responseZeloCriptografia, process.env.REACT_APP_KEYCRYPTO).toString(CryptoJS.enc.Utf8))
		}
		return responseEncrypt
	} catch (err) {
		console.log(err);
	}
}

export function interceptorResponseErrorAxios(error) {
	try {
		const { responseZeloCriptografia } = error.response.data
		if (responseZeloCriptografia) {
			error.data = JSON.parse(CryptoJS.AES.decrypt(responseZeloCriptografia, process.env.REACT_APP_KEYCRYPTO).toString(CryptoJS.enc.Utf8))
		}
		return error;
	} catch (err) {
		console.log(err);
	}
}